import { render, staticRenderFns } from "./TermReport.vue?vue&type=template&id=4e1a2c48&scoped=true"
import script from "./TermReport.vue?vue&type=script&lang=js"
export * from "./TermReport.vue?vue&type=script&lang=js"
import style0 from "./TermReport.vue?vue&type=style&index=0&id=4e1a2c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a2c48",
  null
  
)

export default component.exports